import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { NotificationConfig, NotificationService } from './notification.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss',
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({opacity:0}),
        animate(200, style({opacity:1})) 
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(500, style({opacity:0})) 
      ])
    ])
  ]
})
export class NotificationComponent implements OnInit {

  notifications: NotificationConfig[] = [];
  show: boolean = false;

  constructor(private notificationService: NotificationService) { }

  ngOnInit() {
    this.notificationService.onShow.subscribe((eventData: any)=>{
      this.notifications.unshift(eventData);
      setTimeout(() => {
        const index = this.notifications.indexOf(eventData);
        if (index >= 0) {
          this.notifications.splice(index, 1);
        }
    }, eventData.timeout ? eventData.timeout : 5000);
    })
  }

  deleteNotification(index: number) {
    this.notifications.splice(index,1);
  }
}
